/**
 * Virtual any type for the property decorator.
 */
var Any =
/** @class */
function () {
  function Any() {}

  return Any;
}();

export { Any };